import { description } from '../Typography/Text'
import styled from 'styled-components'

export const Label = styled.label`
  position: absolute;
  top: 2rem;
  opacity: 0.5;
  left: 0;
  pointer-events: none;
  color: ${(p) => p.theme.colors.shades[700]};
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 0;
  ${description};
`
